import { Typography } from 'antd';
import React from 'react';

import { UserAvatar } from '@common/components';
import Auth, { AccountInfoType } from 'works/legacy/lib/auth';
import { Colors } from '@common/tokens';
import { AccountAvatar } from '@identity/components';

import { AccountItem } from './_account-item';

const { Text } = Typography;

export const AccountLeading = ({
  current,
}: {
  current: AccountInfoType | undefined;
}) => (
  <div className="account-leading">
    <AccountItem mode="appbar">
      <>
        <UserAvatar
          textAsInitials={Auth.name()}
          backgroundColor={Colors.elmDarkest}
        />
        {current && (
          <span className="stacked-avatar">
            <AccountAvatar account={current} size={40} />
          </span>
        )}
      </>
      <>
        <Text className="body-medium-medium">{Auth.entityName()}</Text>
        <Text className="body-small-book" type="secondary">
          {Auth.membershipRole()}
        </Text>
      </>
    </AccountItem>
    <style jsx>{`
      .account-leading {
        text-wrap: nowrap;
      }
      .account-leading :global(.stacked-avatar) {
        margin-left: -12px;
      }
      .account-leading :global(.body-medium-medium) {
        line-height: 20px;
        font-weight: 500;
      }
      .account-leading :global(.body-small-book) {
        font-size: 12px;
        line-height: 16px;
        font-weight: 400;
      }
    `}</style>
  </div>
);
